import Img from './img'

export { Img }